export const paramsTranslationsMap: Record<string, string> = {
    'productStructure.structure': 'room.filter.label_structure',
} as const;
